import { IDeThiProgressRequest } from "../../model/request/de-thi/IDeThiProgressRequest";
import { ISMT_DeThi_Request } from "../../model/request/de-thi/ISMT_DeThi_Request";
import { ITongHopTheoDotRequest } from "../../model/request/de-thi/ITongHopTheoDotRequest";
import { ITongHopDeThiVietRequest } from "../../model/request/de-thi/ITongHopDeThiVietRequest";
import { ISMT_DeThi } from "../../model/respone/de-thi/ISMT_DeThi";
import { ISMT_DeThi_Vm } from "../../model/respone/de-thi/ISMT_DeThi_Vm";
import { apiClient } from "../apiClient";
export const DE_THI_ENDPOINT = "de-thi";
export const deThiApi = {
  Select: (payload: ISMT_DeThi_Request) =>
    apiClient.post(`${DE_THI_ENDPOINT}/select-by-request`, payload),
  SelectById: (id: number) => apiClient.get(`${DE_THI_ENDPOINT}/${id}`),
  Insert: (payload: ISMT_DeThi) =>
    apiClient.post(`${DE_THI_ENDPOINT}`, payload),
  Update: (payload: ISMT_DeThi) => apiClient.put(`${DE_THI_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${DE_THI_ENDPOINT}/${id}`),
  DeleteMultiple: (ids: number[]) =>
    apiClient.put(`${DE_THI_ENDPOINT}/delete-multiple`, ids),
  SelectQuestionAnswer: (id_dethi: number) =>
    apiClient.get(`${DE_THI_ENDPOINT}/chi-tiet/${id_dethi}`),
  Progress: (payload: IDeThiProgressRequest) =>
    apiClient.post(`${DE_THI_ENDPOINT}/progress`, payload),
  ChangeQuestion: (payload: ISMT_DeThi_Vm) =>
    apiClient.post(`${DE_THI_ENDPOINT}/change-question`, payload),
  TongHopTheoDot: (payload: ITongHopTheoDotRequest) =>
    apiClient.post(`${DE_THI_ENDPOINT}/tong-hop-theo-dot`, payload),
  ExportTongHop: (payload: ITongHopTheoDotRequest) =>
    apiClient.post(`${DE_THI_ENDPOINT}/export-tong-hop-theo-dot`, payload),
  TongHopDeThiViet: (payload: ITongHopDeThiVietRequest) =>
    apiClient.post(`${DE_THI_ENDPOINT}/tong-hop-de-thi-viet`, payload),
};
